module.exports = __webpack_public_path__ + "static/img/2.62b5e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/delivery/2.png
// module id = fmsJ
// module chunks = 1